import { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const useLeafletControlContainer = (position = 'topright') => {
  const map = useMap(); // Leaflet map instance
  const [controlContainer, setControlContainer] = useState(null);

  useEffect(() => {
    // Creates a div element to serve as the control's container
    const controlContainerDiv = L.DomUtil.create('div', 'fusion-leaflet-control-container');
    
    // Creates a subclass of L.Control
    const Control = L.Control.extend({
      // Adds the control to the map
      onAdd() {
        return controlContainerDiv;
      },
      // Cleans up when the control is removed from the map
      onRemove() {},
    });

    const control = new Control({ position });
    control.addTo(map);

    // State is used to trigger a re-render so that the control container renders immediately.
    setControlContainer(controlContainerDiv);

    // Cleanup function to remove the control from the map when the component unmounts
    return () => control.remove();
  }, [map, position]);

  return controlContainer;
};
export default useLeafletControlContainer;
